export default "__VITE_IMAGE_ASSET__8a901a74__";